/**
 * @项目名称: work
 * @功能名称: vue版本的fundebug 全局方法, filters 每一项的key只能有一个，后面的会覆盖前面规则
 * @params: Object | {
 *  apikey: String,
 *  appversion: '',
 * }
 * @文件名称: fundebugConfig
 * @Date: 2019/11/11
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */

import * as fundebug from "fundebug-javascript";
import fundebugVue from "fundebug-vue";
import cookie from 'bjxy-common/helper/cookie'
import Vue from 'vue'
const config = {
  apikey: "",
  appversion: "", // 应用版本
  releasestage: "production",
  metaData:{},
  setHttpBody : true,
  httpTimeout: 31000,
  silentDev : true,
  silentConsole: true,
  domain:location.href.split('?')[0],
}
const filters = [
  {
    message: /^Script error\.$|^ReferenceError$|JSBridge|vivoNewsDetailPage|setWebViewFlag|TouTiao|onHidden|on_page_disappear|_setbackXML_|processRandomSelector|bridge|jsOnMessage|pajkOnMessage|x5onSkinSwitch|getElementById|getAndroidUnionSeries|MPing|property|BecomeActive|ResignActive|_plusready_dispatch|onAudioStateChanged|goToGetres|appWebGLStart|appWebGLStop|vivo|qbSniffJsVersion|WeixinJSBridge is not defined$|sogouMobileExplorer|vivoNewsDetailPage|x5onSkinSwitch is not defined$|sendData is not defined$|tad_get_back_gesture_enabled$|promise/g
  },
  {
    res:{
      status:/^0$/
    }
  },
  {
    target: {
      src: /revideo/g
    }
  },
  {
    target: {
      tagName: /^IMG$/,
      status: "inexistence"
    }
  }
]

export default function(options={}){
  if(options.filters && Array.isArray(options.filters)){
    options.filters = filters.concat(options.filters)
  }else {
    options.filters = filters
  }
  fundebug.init( Object.assign(config,options))
  Object.defineProperty(fundebug,'metaData',{
    get: function () {
      return {
        uid:cookie.get('uid'),
        uuid:cookie.get('uuid')
      }
    }
  })
  fundebugVue(fundebug, Vue);
}
var dom = document.createElement('script');
dom.type = 'text/javascript';
dom.async = true;
dom.src = 'https://xcfs-public.xystatic.com/10009/fundebug.revideo.0.6.0.min.js';
document.getElementsByTagName('body')[0].appendChild(dom);
